var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(_vm.type, {
    tag: "component",
    staticClass: "info-content",
    attrs: { canBack: _vm.canBack, params: _vm.params }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }